/* CRTD Scroll Choreography — IntersectionObserver-driven section reveal.
   Spec §2.4. Sections fade up on intersection; italic <em> arrives ~120ms after its line. */
(function () {
  'use strict';

  if (typeof IntersectionObserver === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const css = `
    [data-crtd-reveal] {
      opacity: 0;
      transform: translateY(16px);
      transition: opacity 400ms cubic-bezier(0.2,0,0,1), transform 400ms cubic-bezier(0.2,0,0,1);
    }
    [data-crtd-reveal][data-revealed="true"] {
      opacity: 1;
      transform: none;
    }
    [data-crtd-reveal] em,
    [data-crtd-reveal] .crtd-em-rev,
    [data-crtd-reveal] .crtd-stmt-em {
      opacity: 0;
      transition: opacity 500ms cubic-bezier(0.2,0,0,1) 120ms;
    }
    [data-crtd-reveal][data-revealed="true"] em,
    [data-crtd-reveal][data-revealed="true"] .crtd-em-rev,
    [data-crtd-reveal][data-revealed="true"] .crtd-stmt-em {
      opacity: 1;
    }
  `;
  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.setAttribute('data-revealed', 'true');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  document.querySelectorAll('[data-crtd-reveal]').forEach((el) => io.observe(el));
})();
